import { useDirectorySearchBox } from '../../hooks/useDirectorySearchBox';

import { SearchField } from '@/components/ui/search-field';

type DirectorySearchBoxProps = {
  placeholder?: string;
  className?: string;
};

/**
 * The directory's search box. It owns its typing, so a keystroke re-renders this and not the
 * list around it. The label is the one the end-to-end suites and the Lights-On monitor find the
 * field by, so it changes only together with them.
 */
export function DirectorySearchBox({
  placeholder = 'Enter name, cancer type, or keyword',
  className = 'md:min-w-80 md:flex-1 md:basis-2/5',
}: DirectorySearchBoxProps) {
  const { value, onChangeText, onSubmit, onClear } = useDirectorySearchBox();

  return (
    <SearchField
      testID="directory-search-input"
      label="Search experts"
      placeholder={placeholder}
      value={value}
      onChangeText={onChangeText}
      onSubmitEditing={onSubmit}
      onClear={onClear}
      className={className}
    />
  );
}
